import { oz } from '@weft/utils';

export const SalesforceContactSchema = oz.object({
  Id: oz.string(),
  Name: oz.string(),
  Email: oz.string().nullable(),
  AccountId: oz.string(),
}).openapi('SalesforceContact');

export type SalesforceContact = oz.infer<typeof SalesforceContactSchema>;